import { fetchActive } from "./fetchActive";

export const actions = {
    fetchActive,
};
